module.exports = __webpack_public_path__ + "staticesp/media/paredao_bueno.1030864b.mp4";